/**
 * External dependencies
 */
import { Component } from 'react';
import { useEffect, useState,useCallback } from '@wordpress/element';
import { getSetting } from '@woocommerce/settings';
import { useSelect, useDispatch,select as selectStore } from '@wordpress/data';
import ReCAPTCHA from "react-google-recaptcha";
import ReCAPTCHAEN from "react-google-recaptcha-enterprise";

import './style_frontend.scss';
import {
	CHECKOUT_STORE_KEY,
	PAYMENT_STORE_KEY
} from '@woocommerce/block-data';



const { reCapchaVersion } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { site_key_v2 } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { captcha_lable } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_recapcha_hide_label_checkout } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_recapcha_v2_lang } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { size } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { theme } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_recapcha_domain } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { recapcha_error_msg_captcha_blank } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { refresh_lable } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { disable_submit_btn } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { disable_submit_btn_login_checkout } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { is_enabled_guest } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { is_enabled_logincheckout } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { is_user_login } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_recapcha_guest_recpacha_refersh_on_error } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_recapcha_login_recpacha_refersh_on_error } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { site_key_v3 } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_recapcha_checkout_action_v3 } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_recapcha_wp_disable_to_woo_checkout } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_checkout_nonce } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { use_v2_along_v3 } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { cookiehash_i13 } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_is_enterprise_captcha } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_grecaptcha_instance } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { i13_use_api } = getSetting( 'i13-recaptcha-checkout-block_data', '' );





window.recaptchaOptions = {
  useRecaptchaNet: {i13_recapcha_domain}
};

const Block = ( { children, checkoutExtensionData } ) => {
	const { setExtensionData } = checkoutExtensionData;

	const { setValidationErrors, clearValidationError } = useDispatch(
		'wc/store/validation'
	);


	const {
		hasError,
		isBeforeProcessing
	} = useSelect( ( select ) => {
		const store = select( CHECKOUT_STORE_KEY );
		return {
			hasError: store.hasError(),
			isBeforeProcessing: store.isBeforeProcessing()
		};
	} );


	const {
		isPaymentReady,

	} = useSelect( ( select ) => {
		const store_pay = select( PAYMENT_STORE_KEY );
		return {
			isPaymentReady: store_pay.isPaymentReady()
		};
	} );



	  const hasError2 = useSelect( ( select ) => {
        return select( 'wc/store/checkout' ).hasError();
    } );

	   const isBeforeProcessing2 = useSelect( ( select ) => {
        return select( 'wc/store/checkout' ).isBeforeProcessing();
    } );









function waitElementExistI13(selector) {

  return new Promise((resolve) => {

    if (document.querySelector(selector)) {

	  const element_r = document.querySelector(selector);
      return resolve(element_r);
    }
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {

        resolve(element);
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

function onLoadScript(){

	if((is_enabled_guest==1 && disable_submit_btn==1) || (is_enabled_logincheckout==1 && disable_submit_btn_login_checkout==1) ){



			waitElementExistI13('.wc-block-components-checkout-place-order-button').then(() => {

					if (document.querySelector('.wc-block-components-checkout-place-order-button')){

						const element = document.querySelector('.wc-block-components-checkout-place-order-button');


						var div = document.createElement("span");
								div.style.width = element.offsetWidth+"px";
								div.style.height = element.offsetHeight+"px";
								div.style.left = element.offsetLeft+"px";
								div.style.zIndex = "100";
								div.style.position = "absolute";
								div.innerHTML = "";
								div.setAttribute("title",recapcha_error_msg_captcha_blank);
								div.setAttribute("id",'i13_submit_overlay');
								element.parentNode.insertBefore(div, element);


					}



			});
	}
}



window.addEventListener('resize', function(event){

	if (document.querySelector('.wc-block-components-checkout-place-order-button')){

		const element = document.querySelector('.wc-block-components-checkout-place-order-button');


		if (document.querySelector('#i13_submit_overlay')){

				var div = document.querySelector('#i13_submit_overlay');
				div.style.width = element.offsetWidth+"px";
				div.style.height = element.offsetHeight+"px";
				div.style.left = element.offsetLeft+"px";
				div.style.zIndex = "100";
				div.style.position = "absolute";
				div.innerHTML = "";


		}

	}
});

function onChange(value) {

	//alert(value);
	if((is_enabled_guest==1 && disable_submit_btn==1) || (is_enabled_logincheckout==1 && disable_submit_btn_login_checkout==1) ){
		const element = document.querySelector('#i13_submit_overlay');
		element.remove();
	}

	setExtensionData('i13-recaptcha-checkout-block', 'g-recaptcha-response-v2', value);
	setExtensionData('i13-recaptcha-checkout-block', 'woo-checkout-nonce', i13_checkout_nonce);




}

 if("v2" == reCapchaVersion){

	if((is_enabled_guest && !is_user_login) || (is_enabled_logincheckout && is_user_login)){

			//const errorMessage = validationError?.message;
			let recaptchaRef = React.createRef();


			useEffect( () => {

				//setExtensionData('i13-recaptcha-checkout-block', 'g-recaptcha-response-v2', '');
				setExtensionData('i13-recaptcha-checkout-block', 'woo-checkout-nonce', i13_checkout_nonce);
				setExtensionData('i13-recaptcha-checkout-block', 'cookiehash_i13', cookiehash_i13);
				if ( hasError2 ) {


					if(i13_recapcha_guest_recpacha_refersh_on_error && !is_user_login){

						//setExtensionData('i13-recaptcha-checkout-block', 'g-recaptcha-response-v2', '');
						recaptchaRef.current.reset();

					}
					else if(i13_recapcha_login_recpacha_refersh_on_error && is_user_login){

						//setExtensionData('i13-recaptcha-checkout-block', 'g-recaptcha-response-v2', '');
						recaptchaRef.current.reset();
					}

				}
				if(isBeforeProcessing2){


					setExtensionData('i13-recaptcha-checkout-block', 'g-recaptcha-response-v2', recaptchaRef.current.getValue());

				}



			}, [ hasError,isBeforeProcessing2 ] );


			return (
				<>



							{i13_recapcha_hide_label_checkout?(<></>):(
							<div class="wc-block-components-recaptcha-step__heading">
							<h2 class="wc-block-components-title wc-block-components-recaptcha-step__title i13_recaptcha_title" >{captcha_lable}</h2>
							</div>
							)}
							<div class="wc-block-components-checkout-step__container">

							<div id="i13_recaptcha_v2" class="i13_recaptcha_v2 wc-block-components-checkout-step__content">

							{i13_is_enterprise_captcha?(

								<ReCAPTCHAEN
										ref={recaptchaRef}
										sitekey={site_key_v2}
										onChange={onChange}
										hl={i13_recapcha_v2_lang}
										size={size}
										theme={theme}
										asyncScriptOnLoad={onLoadScript}
									/>

							):(

								<ReCAPTCHA
										ref={recaptchaRef}
										sitekey={site_key_v2}
										onChange={onChange}
										hl={i13_recapcha_v2_lang}
										size={size}
										theme={theme}
										asyncScriptOnLoad={onLoadScript}
									/>

							)}


									<div id="refresh_captcha">
										<a href="javascript:void(0)" onClick={() => { recaptchaRef.current.reset(); }} class="i13resetCaptcha">{refresh_lable}</a>
									</div>
							</div>
							</div>



				</>
			);
	}
	else{

		return (<></>)
	}

 }
 else if("v3" == reCapchaVersion){

	if((is_enabled_guest && !is_user_login) || (is_enabled_logincheckout && is_user_login)){


		let recaptchaloaddone=0;


		useEffect( () => {
		if ( hasError2 ) {

			setTimeout(function(){

				if (document.querySelector('#g-recaptcha_error_v3') && use_v2_along_v3){

					const url = new URL(location.href);
					url.searchParams.set('rand_i13', (Math.random() + 1).toString(36).substring(7));

					location.assign(url.search);
				}

			},2000);



			if(i13_recapcha_guest_recpacha_refersh_on_error && !is_user_login){

				handleReCaptchaVerify();

			}
			else if(i13_recapcha_login_recpacha_refersh_on_error && is_user_login){

				handleReCaptchaVerify();
			}



		}

		if(isPaymentReady){

			handleReCaptchaVerify();

		}


		}, [ hasError,isBeforeProcessing2,isPaymentReady ] );


		const handleReCaptchaVerify = () => {

			if(i13_is_enterprise_captcha){

				window.grecaptcha.enterprise
					.execute(site_key_v3, { action: i13_recapcha_checkout_action_v3 })
					.then(token => {
						//console.log(token);
						setExtensionData('i13-recaptcha-checkout-block', 'i13_checkout_token_', token);
						setExtensionData('i13-recaptcha-checkout-block', 'woo-checkout-nonce', i13_checkout_nonce);
					})

			}
			else{

					window.grecaptcha
					.execute(site_key_v3, { action: i13_recapcha_checkout_action_v3 })
					.then(token => {
						//console.log(token);
						setExtensionData('i13-recaptcha-checkout-block', 'i13_checkout_token_', token);
						setExtensionData('i13-recaptcha-checkout-block', 'woo-checkout-nonce', i13_checkout_nonce);
					})
			}

		}
		const handleLoaded = _ => {

			if(i13_is_enterprise_captcha){

				window.grecaptcha.enterprise.ready(_ => {

					recaptchaloaddone=1;
					window.grecaptcha.enterprise
					.execute(site_key_v3, { action: i13_recapcha_checkout_action_v3 })
					.then(token => {
						//console.log(token);
						setExtensionData('i13-recaptcha-checkout-block', 'i13_checkout_token_', token);
						setExtensionData('i13-recaptcha-checkout-block', 'woo-checkout-nonce', i13_checkout_nonce);

						//console.log(i13_recapcha_wp_disable_to_woo_checkout);
						if(i13_recapcha_wp_disable_to_woo_checkout){


							const intervalID = setInterval(() =>  {

								//console.log(recaptchaloaddone);
								if(recaptchaloaddone){


									handleReCaptchaVerify();

								}


							}, 80 * 1000);


						}
					})
				})

		}
		else{

			window.grecaptcha.ready(_ => {

					recaptchaloaddone=1;
					window.grecaptcha
					.execute(site_key_v3, { action: i13_recapcha_checkout_action_v3 })
					.then(token => {
						//console.log(token);
						setExtensionData('i13-recaptcha-checkout-block', 'i13_checkout_token_', token);
						setExtensionData('i13-recaptcha-checkout-block', 'woo-checkout-nonce', i13_checkout_nonce);

						//console.log(i13_recapcha_wp_disable_to_woo_checkout);
						if(i13_recapcha_wp_disable_to_woo_checkout){


							const intervalID = setInterval(() =>  {

								//console.log(recaptchaloaddone);
								if(recaptchaloaddone){


									handleReCaptchaVerify();

								}


							}, 80 * 1000);


						}
					})
				})
		}



		}

		useEffect(() => {

			    setExtensionData('i13-recaptcha-checkout-block', 'cookiehash_i13', cookiehash_i13);
				const reCapUrl='https://www.google.com';
				const reCapUrlNet='https://www.recaptcha.net';

				// Add reCaptcha
				const script = document.createElement("script");
				if(i13_recapcha_v2_lang){

					script.src = reCapUrlNet+"/recaptcha/"+i13_use_api+"?from=i13&render="+site_key_v3
				}
				else{

					script.src = reCapUrl+"/recaptcha/"+i13_use_api+"?from=i13&render="+site_key_v3
				}
				script.addEventListener("load", handleLoaded)
				document.body.appendChild(script)



		}, [])

		return (
		<>

		 <div
			className="i13-g-recaptcha-v3"
			data-sitekey={site_key_v3}
			data-size="invisible"
			id="i13_recaptcha_v3_checkoutblock"
		></div>
		</>
		);

 }
 else{

		return (<></>)
	}

 }

};

export default Block;
